// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__EtIjk","label":"Category_label__2dIr8","content":"Category_content__1KHQq","header":"Category_header__2Gf8i","location":"Category_location__1HFuz"};